import React from 'react';

import Typography from 'components/Typography';

import { IDescriptionText } from './interfaces';

export const DescriptionText: React.FC<IDescriptionText> = ({
  value,
  ...props
}) => {
  return <Typography {...props}>{value}</Typography>;
};
